import styles from './PayList.module.css'
import WaitLoader from "../../WaitLoader/WaitLoader";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
export default function PayList()
{
    const payListData =useRef(null)
    const [ldrPayList,rsPayList,exPayList] = useApiQuery("/core/pay/list","get",payListData);
    const [payList, setPayList] = useState<any[]>([])


    useEffect(()=>{loadPayList()},[payListData])
    const loadPayList = () =>{
        exPayList().then((e)=>{
            if(e?.success)
            {
                setPayList(e?.payload)
            }
        })
    }


    return(
        <div className={styles.mainCont}>
            <div className={styles.title}>Последние платежи</div>
            <WaitLoader loading={ldrPayList} api={rsPayList} onlyLoading={true}>
                <TableItem
                    data={payList}
                    column={[
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"ctn",
                            title: "Номер",
                            mode: "f",
                        },
                        {
                            type: 4,
                            maxLen: 20,
                            fieldId:"date",
                            title: "Дата",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 40,
                            fieldId:"idPay",
                            title: "id",
                            mode: "f",
                        },
                        {
                            type: 1,
                            maxLen: 20,
                            fieldId:"amount",
                            title: "Сумма",
                            mode: "sf",
                        },

                    ]}
                    onPageCount={50}
                    onReload={loadPayList}
                    exportExcel={true}
                    //onRecord={(e)=>setCurBan(e)}
                    saveState={false}




                ></TableItem>
            </WaitLoader>

        </div>
    )
}